angular.module('bmsApp.settings')
	.factory('RiskAssessmentQuestionSvc', function (CRUDSvc, $rootScope, $q, $modal, notify) {

		var prefix = 'api/settings/risk-assessment/question/';
		function index(params) {
			return CRUDSvc.get(prefix+'index', params);
		}

		function save(params) {
			return CRUDSvc.post(prefix+'save', params);
		}

		function read(id) {
			return CRUDSvc.get(prefix+'read/' + id);
		}

		function options() {
			return CRUDSvc.get(prefix+'options');
		}

		function remove(id) {
			return CRUDSvc.get(prefix+'delete/' + id);
		}

		function showSaveModal(license, question) {
			var modalInstance = $modal.open({
				animation: true,
				templateUrl: 'ng/settings/riskAssessmentQuestions/templates/QuestionSaveModal.html',
				controller: 'RiskAssessmentQuestionModalFormCtrl',
				size: 'lg',
				scope: $rootScope,
				backdrop: 'static', // disable click-outside closing modal
				resolve: {
					license: function () {
						return angular.copy(license);
					},
					question: function () {
						return angular.copy(question);
					}
				}
			});

			modalInstance.result.then(function (result) {
				if (result.success === true) {
					var message;
					switch (result.action) {
						case 'create':
							message = 'Question created successfully';
							break;
						case 'update':
							message = 'Question updated successfully';
							break;
						default:
							message = 'Success';
							break;
					}
					notify({
						message: message
					});
				}
				else {
					notify({
						message: result.error,
						classes: 'error'
					});
				}
			}, function () {
				// closed
			});

			return modalInstance.result;
		}

		return {
			index: index,
			save: save,
			read: read,
			options: options,
			remove: remove,
			showSaveModal: showSaveModal,
		};

	});
